// extracted by mini-css-extract-plugin
export var iconAndTextWrapper = "SupportOptions-module--icon-and-text-wrapper--655a0";
export var iconWrapper = "SupportOptions-module--icon-wrapper--178f7";
export var selectMenuWrapper = "SupportOptions-module--select-menu-wrapper--21aa4";
export var supportOptions = "SupportOptions-module--support-options--61f26";
export var switchOrgContainer = "SupportOptions-module--switch-org-container--c3456";